import { CartAddEvent } from "@theme/events";
import { EVENTS } from "./constants";

window.vehicleManager.pubsub.subscribe(
  EVENTS.comparisonAddedToCart,
  () => {
    // Dispatch a CartAddEvent when a product is added to cart from comparison
    document.dispatchEvent(new CartAddEvent({}, ""));
  },
  { replayLast: true },
);
